import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { ToastProvider } from './components/ToastProvider';
import { isNative } from './lib/platform';
import './styles/tokens.css';
import './styles/app.css';

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element in index.html');

/*
 * Ordinea providerilor nu e la intamplare: AuthProvider anunta prin toast cand
 * sesiunea se pierde in timpul lucrului, deci ToastProvider trebuie sa fie
 * deasupra lui. Routerul e cel mai de sus fiindca si loginul, si aplicatia se
 * deseneaza prin rute.
 *
 * Pe web ramane BrowserRouter, cu adrese curate, exact ca pana acum. In carcasa
 * nativa nu exista server care sa serveasca `index.html` pe o cale adanca -
 * fisierele sunt servite dintr-un director impachetat in aplicatie - iar o
 * reincarcare pe `/catalog/30` ar da pagina alba. HashRouter tine ruta dupa
 * diez, unde nimeni nu incearca s-o rezolve ca fisier.
 */
const Router = isNative ? HashRouter : BrowserRouter;

createRoot(container).render(
  <StrictMode>
    <Router>
      <ToastProvider>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ToastProvider>
    </Router>
  </StrictMode>,
);
